export default __webpack_public_path__ + "static/media/3.96430497.png";